import React, {useCallback, useEffect, useState} from "react";
import Styles from './styles.module.scss';

import logo from '../../theme/assets/other/ftf_cabinet_logo.png';
import googleIcon from '../../theme/assets/svg/ftf_google_icon.svg';
import {useNavigate} from "react-router-dom";
import {
    classicLogin,
    classicLoginFailure, googleWidgetAuthorization,
} from "../../store/main/action";
import {useDispatch, useSelector} from "react-redux";
import {useGoogleLogin} from "@react-oauth/google";


const LogPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authStatus = useSelector(store => store.main.authorizationStatus);
    const formErr = useSelector(store => store.main.classicLoginErr);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const sendFormHandler = useCallback(()=>{
        dispatch(classicLogin({email, password}));
    }, [dispatch, email, password])

    const login = useGoogleLogin({
        flow: 'auth-code',
        scope: 'openid email profile',
        onSuccess: async ({ code }) => {
            dispatch(googleWidgetAuthorization({ code }));
        },
        onError: () => console.log('Ошибка входа'),
    });

    useEffect(() => {
        if (authStatus){
            navigate('/matrix');
        }
    }, [authStatus, navigate]);

    useEffect(() => {
        const onKeyDown = e => {
            if(e.keyCode === 13) {
                sendFormHandler();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [sendFormHandler]);
    
    return (
        <section className={`${Styles.container} ${Styles.pagePadding}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={Styles.posWrap}>
                    <div className={Styles.logoWrap}>
                        <div className={Styles.logoWrapIconWrap}>
                            <img src={logo} alt="F#ck the Fomo"/>
                        </div>
                        <div className={Styles.logoWrapText}>F#ck the Fomo</div>
                    </div>
                    <div className={Styles.formWrap}>
                        <div className={Styles.formTitle}>Sign in to your account</div>
                        <div className={Styles.formBox}>
                            <div className={`${Styles.inputWrap} ${formErr?.email ? Styles.inputWrapWithErr : null}`}>
                                <div className={Styles.inputTitle}>Your email</div>
                                <input
                                    type="text"
                                    className={Styles.ftfBorderInput}
                                    placeholder="example@gmail.com"
                                    value={email}
                                    onChange={(e)=>{setEmail(e.target.value)}}
                                    onKeyDown={(event)=>{
                                        if (formErr.email){
                                            delete formErr.email;
                                            dispatch(classicLoginFailure(formErr));
                                        }
                                    }}
                                />
                                <div className={`${Styles.inputErr}`}>{formErr?.email ? formErr.email : ''}</div>
                            </div>
                            <div className={`${Styles.inputWrap} ${formErr?.password ? Styles.inputWrapWithErr : null}`}>
                                <div className={Styles.inputTitle}>Your password</div>
                                <input
                                    type="password"
                                    className={Styles.ftfBorderInput}
                                    placeholder="********"
                                    value={password}
                                    onChange={(e)=>{setPassword(e.target.value)}}
                                    onKeyDown={(event)=>{
                                        if (formErr.password){
                                            delete formErr.password;
                                            dispatch(classicLoginFailure(formErr));
                                        }
                                    }}
                                />
                                <div className={`${Styles.inputErr}`}>{formErr?.password?.[0] ? formErr.password[0] : ''}</div>
                            </div>
                        </div>
                        <div className={Styles.ftfBorderBtn} onClick={()=>{sendFormHandler()}}>Sign in</div>
                    </div>
                    <div className={Styles.link}>Forgot your password? <span onClick={()=>{navigate('/reset-password')}}>Reset</span></div>
                    <div className={Styles.link}>Don't have an account yet? <span onClick={()=>{navigate('/sign-up')}}>Sign up</span></div>
                    <div className={Styles.btnsWrap}>
                        <div className={`${Styles.btnsWrapItem} ${Styles.ftfBorderBtn}`}>
                            <div className={`${Styles.btnsWrapItemIconWrap}`}>
                                <img src={googleIcon} alt="Sign in with Google"/>
                            </div>
                            <div className={`${Styles.btnsWrapItemText}`}>Sign in with Google</div>
                            <div className={`${Styles.googleWrap}`}>
                                <button onClick={() => login()}>Войти через Google</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LogPage;
